export const COUNTRIES = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
    "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
    "Bhutan", "Bolivia", "Brazil", "Brunei", "Bulgaria", "Cambodia", "Canada", "Chile", "China",
    "Colombia", "Costa Rica", "Croatia", "Cuba", "Czechia", "Denmark", "Egypt", "Fiji", "Finland",
    "France", "Germany", "Greece", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
    "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait",
    "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Liechtenstein", "Lithuania", "Luxembourg",
    "Madagascar", "Malaysia", "Maldives", "Mexico", "Moldova", "Monaco", "Mongolia", "Morocco",
    "Myanmar", "Nepal", "Netherlands", "New Zealand", "North Korea", "Norway", "Philippines",
    "Poland", "Portugal", "Qatar", "Romania", "Russia", "Singapore", "South Africa", "South Korea",
    "Spain", "Sri Lanka", "Sweden", "Switzerland", "Taiwan", "Thailand", "Turkiye", "UAE",
    "UK", "USA", "Vietnam"
];

/* global require -- webpack-only require.context; see note */
// NOTE: require.context is a webpack API with no standard equivalent. The Vite/Astro
// equivalent is import.meta.glob, and the two are not interchangeable. If apps/web ever
// moves to Vite, this is the migration point. Do not import countryUtils from a Vite
// or Vitest context until then.

// Scans the folder for all images
const context = require.context('../assets/countries', false, /\.(png|jpe?g|svg)$/);
const images = {};

// Build the dictionary: { "northkorea": module, "japan": module, ... }
context.keys().forEach((key) => {

    // Turn "northkorea.jpg" into "northkorea"
    const countryCode =
        key.replace('./', '')
            .replace(/\.(png|jpe?g|svg)$/, '')
            .toLowerCase()
            .replace(/\s+/g, '');

    images[countryCode] = context(key);
});

const ALIASES = {
    "unitedstates": "usa",
    "unitedkingdom": "uk",
    "unitedarabemirates": "uae",
    "turkey": "turkiye"
};

export const getCountryImage = (countryName) => {
    if (!countryName) return null;

    // Normalize input: "North Korea" -> "northkorea"
    let normalized = countryName.toLowerCase().replace(/\s+/g, '');

    // Handle aliases
    const alias = ALIASES[normalized];

    return images[normalized] || images[alias] || null;
};